import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, AlertTitle, Button } from "@mui/material";

/**
 * Banner for director/bursar when students have uploaded fee payment proof awaiting verification.
 */
const PendingFeePaymentAlert = ({
    count = 0,
    verifyPath = "/Admin/fees/payment-submissions",
    sx = {},
}) => {
    if (!count || count <= 0) return null;

    return (
        <Alert
            severity="warning"
            sx={{ mb: 2, borderRadius: 2, ...sx }}
            action={
                <Button color="inherit" size="small" component={RouterLink} to={verifyPath} sx={{ fontWeight: 700 }}>
                    Review now
                </Button>
            }
        >
            <AlertTitle sx={{ fontWeight: 700 }}>
                {count} student payment{count === 1 ? "" : "s"} awaiting verification
            </AlertTitle>
            A student uploaded proof of payment. Confirm the cash-in or bank transfer against your records and check
            the fee balance before approving — the proof may be invalid or doctored.
        </Alert>
    );
};

export default PendingFeePaymentAlert;
